import useScrollReveal from "@/hooks/useScrollReveal";

interface TrustItem {
  icon: string;
  label: string;
  value: string;
}

interface TrustBarProps {
  items: TrustItem[];
}

export default function TrustBar({ items }: TrustBarProps) {
  const ref = useScrollReveal();

  return (
    <section className="bg-charcoal border-b border-stone-800/80 relative overflow-hidden">
      {/* Subtle gold top accent line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />

      <div ref={ref} className="sr-hidden px-6 lg:px-14 py-7">
        <div className="flex flex-wrap items-stretch justify-center lg:justify-between gap-0 max-w-7xl mx-auto">
          {items.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 px-6 lg:px-10 py-4 ${
                i < items.length - 1 ? "border-r border-stone-800/70" : ""
              } flex-1 min-w-[160px] justify-center lg:justify-start`}
            >
              <div className="w-9 h-9 flex items-center justify-center flex-shrink-0 text-gold">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div>
                <p className="text-gold font-display text-base font-bold leading-tight">{item.value}</p>
                <p className="text-stone-500 font-sans text-[10px] uppercase tracking-[0.16em] mt-0.5 whitespace-nowrap">{item.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
